import { useRef, useState } from 'react'
import {
  Card,
  Typography,
  Stack,
  ImageList,
  ImageListItem,
  ListSubheader,
  ImageListItemBar,
  Box,
  Button,
  Divider,
  Grid,
  TextField,
  AvatarGroup,
  Tooltip,
  Avatar,
  Snackbar,
  IconButton,
  makeStyles,
  Skeleton,
  Checkbox,
  Badge,
  Tabs,
  Tab,
} from '@material-ui/core'
import { useTheme, withStyles } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { ThumbUpAltOutlined, ThumbDownOffAltOutlined, CancelOutlined, Link, Notes, Description, PictureAsPdf, CalendarToday, Event
} from '@material-ui/icons'
import { sentenceCase } from 'change-case'
import moment from 'moment'
import Scrollbar from 'src/components/Scrollbar'
import {
  ref as imageref,
  uploadBytesResumable,
  getDownloadURL,
} from '@firebase/storage'
import { storage } from 'src/firebase/firebase'
import { REST_API_END_POINT } from 'src/constants/Defaultvalues'
import { useSnackbar } from 'notistack'
import axios from 'axios'
import { LoadingButton } from '@material-ui/lab'
import { UserMoreMenu } from '../user/list'
import Label from 'src/components/Label'
import Modal from '../blog/ProjectModel'
import { AccountNotifications } from '../user/account'
import { empty } from 'src/Helpers/Common'
import { Icon } from '@iconify/react'
import arrowLeftOutlined from '@iconify/icons-ant-design/arrow-left-outlined';
import arrowRightOutlined from '@iconify/icons-ant-design/arrow-right-outlined';
import { DialogAnimate } from 'src/components/animate'
import filePdfIcon from '@iconify/icons-mdi/file-pdf';
import emailFillIcon from '@iconify/icons-eva/email-fill';
import SendDesignsEmailModal from './SendDesignsEmailModal';

const useStyles = makeStyles((theme) => ({
  attachmentBox: {
      cursor: 'pointer',
      display: 'flex',
      borderRadius: '6px',
      backgroundColor: '#172e34',
      padding: theme.spacing(1),
      margin: theme.spacing(1, 0),
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative', 
      height: '100px', 
      overflow: 'hidden'
  },
  attachmentIcon: {
      marginRight: theme.spacing(1),
  },
  delete:{
      m:2,
      display:'flex',
      justifyContent:'flex-end' 
    },
  checkbox: {
      position: 'absolute',
      top: theme.spacing(1), 
      right: theme.spacing(1), 
  },
  checkboxContainer: {
      position: 'absolute',
      top: theme.spacing(1),
      right: theme.spacing(1),
  },
  dialogContent: {
      padding: theme.spacing(3),
      maxWidth: 768,
      margin: 'auto',
      display: 'flex',
      flexDirection:'column',
      justifyContent: 'center',
      alignItems: 'center',
  },
  gridContainer: {
      height: 'auto',
  },
}));

const StyledTabs = withStyles({
  root: {
    minHeight: 45,
  },
  indicator: {
    display: "none", // hide default underline
  },
})(Tabs);

const StyledTab = withStyles((theme) => ({
  root: {
    minHeight: 45,
    flex: 1, // 50% width
    maxWidth: "none",
    textTransform: "none",
    fontWeight: 600,
    borderRadius: 6,
    margin: "0 4px",
    transition: "0.2s",

    "&.Mui-selected": {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.text.primary,
    },

    "&:not(.Mui-selected)": {
      color: theme.palette.text.primary,
      border: `1px solid ${theme.palette.primary.main}`, // ✅ FIXED
    },
  },
}))(Tab);

const getStatusColorAndLabel = (status, hold, design_order_job_status, send_client_app_req, designs, is_from_client, is_in_queue) => {
  // HOLD: hold=1 AND status !=0
  if (hold == 1 && status != 0) {
    return {
      color: 'warning',
      label: 'Status: Hold',
    }
  }
  
  // REJECTED: status=6 AND hold=0
  if (status == 6 && hold == 0) {
    return {
      color: 'error',
      label: 'Status: Rejected',
    }
  }
  
  // APPROVED: status=2 AND hold=0
  if (status == 2 && hold == 0) {
    return {
      color: 'success',
      label: 'Status: Approved',
    }
  }
  
  // DESIGN JOB COMPLETED: design_order_job_status = 3 AND send_client_app_req=0 AND status !=0 AND hold = 0
  if (design_order_job_status == 3 && send_client_app_req == 0 && status != 0 && hold == 0) {
    return {
      color: 'success',
      label: 'Status: Design Job Completed',
    }
  }
  
  // Check if there are design attachments (doa.id IS NOT NULL equivalent)
  // Check for any attachment with isDesign == 1
  const hasDesignAttachments = designs && Array.isArray(designs) && designs.length > 0 ;
  
  // For status 1, check conditions in priority order
  if (status == 1 && hold == 0) {
    // Handle null/undefined for design_order_job_status
    const jobStatus = design_order_job_status != null ? design_order_job_status : 0;
    
    // AWAITING APPROVAL: status=1 AND hold=0 AND send_client_app_req=1 AND doa.id IS NOT NULL
    if (send_client_app_req == 1 && hasDesignAttachments) {
      return {
        color: 'warning',
        label: 'Status: Awaiting Approval',
      }
    }
    
    // IN DESIGN: doa.id IS NOT NULL AND status = 1 AND hold = 0 AND send_client_app_req=0 AND design_order_job_status != 3
    // This must be checked before NEW to ensure it takes priority when attachments exist
    // if (send_client_app_req == 0 && jobStatus != 3 && hasDesignAttachments) {
    if (send_client_app_req == 0 && jobStatus == 2) {
      return {
        color: 'info',
        label: 'Status: In Design',
      }
    }
    
    // NEW: status=1 AND hold=0 AND doa.id IS NULL AND design_order_job_status != 3 AND send_client_app_req=0
    // Only show NEW if there are NO design attachments
    if (send_client_app_req == 0 && jobStatus == 1 && is_in_queue == 1) {
      return {
        color: 'info',
        label: 'Status: In Queue',
      }
    }
    if (send_client_app_req == 0 && jobStatus == 1 && is_in_queue == 0) {
      return {
        color: 'info',
        label: 'Status: New',
      }
    }
    
    // Default fallback for status 1
    return {
      color: 'info',
      label: 'Status: Open',
    }
  }
  
  // Other status cases
  switch (status) {
    case 3:
      return {
        color: hold == 1 ? 'warning' : 'success',
        label: hold == 1 ? 'Status: Hold' : 'Status: Approved',
      }
    case 4:
      return {
        color: hold == 1 ? 'warning' : 'warning',
        label: hold == 1 ? 'Status: Hold' : 'Status: Draft',
      }
    case 5:
      return {
        color: hold == 1 ? 'warning' : 'warning',
        label: hold == 1 ? 'Status: Hold' : 'Status: Closed',
      }
    case 6:
      return {
        color: hold == 1 ? 'warning' : 'error',
        label: hold == 1 ? 'Status: Hold' : 'Status: Rejected',
      }
    default:
      return {
        color: hold == 1 ? 'warning' : 'default',
        label: hold == 1 ? 'Status: Hold' : 'Status: Open',
      }
  }
}

export default function ViewDesignOrderDetails({
  designs,
  referenceFiles,
  products,
  user,
  setDesigns,
  details,
  fetchRequestDetails,
  isRequest,
  requestId,
  signAgreements,
  customTemplate,
  questionnaireTemplate,
  allDataEmpty,
  portfolio,
  project,
  clientDetails,
  teamMembers,
  invoice,
  quotation,
  proposalView,
  isDesign,
  isFromTask,
  setRefresh,
  refresh,
  designStatus
}) {
console.log('detailsdetails=',details)
console.log('isDesignisDesign=',isDesign)
  const fileInputRef = useRef(null)
  const theme = useTheme()
  const { enqueueSnackbar } = useSnackbar()
  const {
    name,
    notes,
    description,
    services,
    start_date,
    due_date,
    status,
    reason,
    reject_file,
    reject_file_type,
    hold_reason,
    hold,
    reasonWithQb,
    estimate_id,
    added_by,
    awarded,
    rfpQbId,
    community_name,
    id,
    send_client_app_req
  } = details
  const submissionDate = moment.unix(start_date).format('MM/DD/YYYY')
  const endDate = moment.unix(due_date).format('MM/DD/YYYY')
  const xs = useMediaQuery(theme.breakpoints.down('xs'))
  const sm = useMediaQuery(theme.breakpoints.down('sm'))
  const mdd = useMediaQuery(theme.breakpoints.down('md'))
  const xld = useMediaQuery(theme.breakpoints.up('xl'))
  const [progress, setProgress] = useState(false)
  const [modalClose, setModalClose] = useState(false)
  const [openProductModel, setOpenProductModel] = useState(false)
  const [openReasonModal, setOpenReasonModal] = useState(false)
  const [itemId, setItemId] = useState(null)
  const [reasonText, setReasonText] = useState('')
  const [openImageModal,setOpenImageModal] = useState(false)
  const [openImageModalReference,setOpenImageModalReference] = useState(false)
  const [currentImageIndex, setCurrentImageIndex] = useState(null);
  const classes = useStyles();
  const [selectedPDF, setSelectedPDF] = useState(null);
  const [selectedPDFItem, setSelectedPDFItem] = useState(null);
  const [pdfLoading, setPdfLoading] = useState(true);
  const [openPDFModal, setOpenPDFModal] = useState(false);
  const [useOfficeViewer, setUseOfficeViewer] = useState(true);
  const [activeTab, setActiveTab] = useState('designs');
  const [activeTabNew, setActiveTabNew] = useState('designs');
  const [selectedDesigns, setSelectedDesigns] = useState([]);
  const [openEmailModal, setOpenEmailModal] = useState(false);
  const [emailModalDesigns, setEmailModalDesigns] = useState([]);

  const approvedDesigns = designs?.filter(item=>item.approved == 1)
  const isClient = user?.isClient;
  let userType = isClient ? 3 : user?.user_type;
  let userId = user.user_id

  if(user.added_by_client && user.parent_user_type && user.parent_id) {
    userId = user.parent_id
    userType =3 //user.parent_user_type
  }

  console.log("detailsdetails",invoice);
  const handleUpdateDesign = (data) => { 
    setModalClose(true)
    data.requestId = details.id
    data.userId = user.user_id
    if (data.approved) data.approved_by = user.user_id
    if(data.approved === 0 && reasonText === ''){
      enqueueSnackbar('Please add Reason', { variant: 'error' })
      return
    }
    let productName = ''
    if (data?.hasOwnProperty('product_name')) {
      productName = data?.product_name
      delete data?.product_name;
    }

    axios
      .post(`${REST_API_END_POINT}request/update-designs`, data)
      .then((res) => {
        if (res.data.status === 1) {
          enqueueSnackbar(data.approved === 1 ? 'Design has been Approved' : data.product_id ? `Design has been linked with ${productName}` : data?.status==0 ? 'Design has been Deleted' : 'Design has been Rejected', { variant: 'success' })
          fetchRequestDetails()
        } else {
          enqueueSnackbar(res.data.message, { variant: 'error' })
        }
        setItemId(null)
        setModalClose(false)
        setOpenProductModel(false)
        setOpenReasonModal(false)
        setReasonText('')
      })
  }
  const handleDeleteDesign = (data) => { 
    axios
      .post(`${REST_API_END_POINT}design/delete-design`, data)
      .then((res) => {
        if (res.data.status === 1) {
          enqueueSnackbar('Design has been Deleted' , { variant: 'success' })
          setRefresh(!refresh)
        } else {
          enqueueSnackbar(res.data.message, { variant: 'error' })
          setRefresh(!refresh)
        }
      })
  }

  const handleFileChange = async (event) => {
    const file = event.target.files[0]
    const fileExtension = file?.name?.split('.')?.pop()?.toLowerCase();
    const Filename = new Date().getTime() + file?.name

    // const isImage = file?.type?.startsWith('image/');
    // const isPdf = file?.type === 'application/pdf';
    const isImage = file?.type?.startsWith('image/') || file?.type === 'img' || file?.type === 'image';
    const isPdf = file?.type === 'application/pdf' || file?.type === "other" || file?.type === "pdf" ;

    if (!isImage && !isPdf){
      enqueueSnackbar('Please select a valid file. Only Images and PDF are allowed', { variant: 'error' })
      return;
    }
    const StorageRef = imageref(storage, Filename)
    const uploadTask = uploadBytesResumable(StorageRef, file)

    uploadTask.on(
      'state_changed',
      (snapshot) => {
        const pro = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100,
        )
        setProgress(true)
      },
      (error) => {
        console.error(error.message)
        setProgress(false)
        enqueueSnackbar('Please upload Image or PDF less than 5 MB', { variant: 'error' });
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {

          const uploaded = [downloadURL]
          const requestId = details.id
          const data = { requestId, userId: user.user_id, uploaded, type:file.type, size:file.size, extension:fileExtension }
          axios
            .post(`${REST_API_END_POINT}request/upload-designs`, data)
            .then((res) => {
              if (res.data.status === 1) {
                setDesigns((pv) => [
                  ...pv,
                  ...res.data.data.map((d) => ({
                    ...d,
                    updated_by: user.person_name,
                  })),
                ])
                enqueueSnackbar(res.data.message, { variant: 'success' })
              } else {
                enqueueSnackbar(res.data.message, { variant: 'error' })
              }
            })
          setProgress(false)
          fetchRequestDetails()
        })
      },
    )
  }
  const approvedCount = designs?.filter(item => item.approved === 1)?.length;
  const rejectedCount = designs?.filter(item => item.approved === 0)?.length;
  
  let borderColor = "GrayText";
  // let borderColor = theme.palette.text.secondary;
  
  // if (rejectedCount > 0) {
  //   borderColor = theme.palette.error.main;
  // } else {
  //   borderColor = theme.palette.success.main;
  // }

  const handleImageClick = (index) => {
    setCurrentImageIndex(index);
    setOpenImageModal(true);
  };
  const handleImageClickReference = (index) => {
    setCurrentImageIndex(index);
    setOpenImageModalReference(true);
  };

  const handlePrevious = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : prevIndex));
  };

  const handleNext = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex < imageDesigns.length - 1 ? prevIndex + 1 : prevIndex));
  };

  const handleSendSelectedDesignsToEmail = () => {
    if (selectedDesigns.length === 0) {
      enqueueSnackbar('Please select at least one design', { variant: 'warning' })
      return
    }
    // Use the base designs array (not filtered by tab) to find selected items from both tabs
    const baseDesigns = details?.send_client_app_req === 1
      ? designs
      : userType == 3 ? approvedDesigns : designs;
    const selectedDesignFiles = baseDesigns?.filter((item) => selectedDesigns.includes(item.id))
    setEmailModalDesigns(selectedDesignFiles)
    setOpenEmailModal(true)
  }

  const handleSendCurrentItemToEmail = (item) => {
    if (!item || !item.id) {
      enqueueSnackbar('No item to send', { variant: 'warning' })
      return
    }
    setEmailModalDesigns([item])
    setOpenEmailModal(true)
  }

  const handleEmailSent = () => {
    setSelectedDesigns([])
  }
  


  const filteredDesigns = details?.send_client_app_req === 1
  ? designs?.filter((item) =>
      activeTab === 'designs' ? item.isDesign === 1 : item.isDesign !== 1
    )
  : userType == 3 ? approvedDesigns : designs;

  const imageDesigns = filteredDesigns?.filter(
    (item) => item.file_type?.startsWith('image/') || item.file_type === 'img' || item.file_type === 'image'
  );
  
  return (
    <Card>
      <Stack sx={{ m: 3 }} spacing={3}>
        <Stack
          direction={{ xs: 'row', sm: 'row' }}
          sx={{ justifyContent: 'space-between' }}
          spacing={{ xs: 3, sm: 2 }}
        >
          <Typography variant="overline" sx={{ color: '#ffffff' }}>
            {name}
            {/* {sentenceCase(name)} */}
          </Typography>
          <Stack direction={{ xs: 'row', sm: 'row' }}
          sx={{ justifyContent: 'space-between' }}
          spacing={{ xs: 3, sm: 2 }}>
          {isFromTask ?
           <Typography fontWeight={'0.09rem'} variant="overline">
              <Label
                sx={{ p: '12px' }}
                variant={
                  theme.palette.mode === 'light' ? 'ghost' : 'filled'
                }
                color={
                  getStatusColorAndLabel(details?.status, details?.hold, details?.design_order_job_status, details?.send_client_app_req, designs, details?.is_from_client, details?.is_in_queue)
                    .color
                }
              >
                {
                  getStatusColorAndLabel(details?.status, details?.hold, details?.design_order_job_status, details?.send_client_app_req, designs, details?.is_from_client, details?.is_in_queue)
                    .label
                }
              </Label>
            </Typography>
          : ''}
        </Stack>
        </Stack>
        {/* {(added_by == 1 && user.user_type!=3) &&
        <Typography variant="subtitle2" sx={{ color: `${(proposalView ? !rfpQbId : (reasonWithQb || !estimate_id)) ? 'red' :'green'}` }}>
          {(proposalView && awarded == null) ? '' : 
          (proposalView ? 
          	(reasonWithQb 
            ? reasonWithQb.split('\n').map((line, index) => (
              <span key={index} style={{ display: 'block' }}>{line}</span>
            )) 
            : 'Not Synced With QuickBooks. A Network Issue has Occurred. Please try again...')
           :
          (estimate_id 
            ? 'Successfully Synced With QuickBooks' 
            : (reasonWithQb 
              ? reasonWithQb.split('\n').map((line, index) => (
                <span key={index} style={{ display: 'block' }}>{line}</span>
              )) 
              : 'Not Synced With QuickBooks. A Network Issue has Occurred. Please try again...')))}
          </Typography>} */}
        <Stack
          direction={{ xs: 'column', sm: 'row',md:'row' }}
          sx={{ justifyContent: 'space-between' }}
          spacing={{ xs: 3, sm: 2 }}
        > 
          <Box sx={{width:'60%'}}>
          <Typography variant="overline" sx={{ color: '#ffffff' }}>
            <strong>Design Order Id :</strong> #{id}
          </Typography>
          <Typography variant="body2" sx={{ color: '#ffffff' }}>
            <strong>Created by :</strong> {clientDetails?.added_by_name || clientDetails?.added_by}
          </Typography>
          <Typography variant="body2" sx={{ color: '#ffffff' }}>
            <strong>Created On :</strong> {details?.created_at && details.created_at > 0 ? moment.unix(details.created_at).format('MM-DD-YYYY hh:mm:ss A') : 'N/A'}
          </Typography>
          <Typography variant="body2" sx={{ color: '#ffffff' }}>
            <strong>Client Name :</strong> {clientDetails?.customer_name}
          </Typography>
          <Typography variant="body2" sx={{ color: '#ffffff' }}>
            <strong>Client Address :</strong> {clientDetails?.customer_address}
          </Typography>
          <Typography variant="body2" sx={{ color: '#ffffff' }}>
            <strong>Client Phone :</strong> {clientDetails?.customer_phone}
          </Typography>
          <Typography variant="body2" sx={{ color: '#ffffff' }}>
            <strong>Project Name :</strong> {community_name}
          </Typography>
          </Box>
          <Box sx={{ width: '35%' }}>
            {(reason || reject_file) ? 
              <Stack display={'flex'} direction={'column'} gap={1}>
                <Box
                  sx={{
                    backgroundColor: '#122227',
                    border: '1px solid #2a3b40',
                    borderRadius: 1,
                    p: 2,
                    mb: 2,
                    maxWidth: 400
                  }}
                >
                  <Stack display={'flex'} direction={'row'} gap={1}>
                    <Typography
                      variant="subtitle2"
                      sx={{
                        color: theme.palette.error.main,
                        fontWeight: 'bold',
                        mb: 1
                      }}
                    >
                      Reject Reason
                    </Typography>
                    {reason && (
                      <Typography
                        variant="body2"
                        sx={{
                          color: '#fff',
                          whiteSpace: 'pre-line',
                          mb: reject_file ? 2 : 0
                        }}
                      >
                        {reason}
                      </Typography>
                    )}
                  </Stack>
                  {reject_file && (
                    reject_file_type === 'application/pdf' ? (
                      <Button
                        variant="outlined"
                        color="primary"
                        fullWidth
                        onClick={() => window.open(reject_file, "_blank")}
                      >
                        View Attached File (PDF)
                      </Button>
                    ) : (
                      <Box
                        component="img"
                        src={reject_file}
                        onClick={() => window.open(reject_file, "_blank")}
                        sx={{
                          width: 120,
                          height: 120,
                          borderRadius: 1,
                          border: '1px solid #ccc',
                          cursor: 'pointer',
                          objectFit: 'cover'
                        }}
                      />
                    )
                  )}
                </Box>
                {hold === 1 &&
                  <Typography variant="subtitle2" sx={{ color:theme.palette.error.main,maxWidth:400,overflowWrap: 'break-word',whiteSpace: 'pre-line', }}>
                  {hold_reason ? `Hold Reason: ${hold_reason}` : ""}
                  </Typography>
                }
              </Stack>
            :''}
            {!user.isVendor && (
              <Stack spacing={1}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <CalendarToday sx={{ color: '#ffffff' }} />
                  <Typography variant="overline" sx={{ color: '#ffffff', fontWeight: 'bold' }}>
                    Requested Start Date:
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'text.primary' }}>
                    {submissionDate}
                  </Typography>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Event sx={{ color: '#ffffff' }} />
                  <Typography variant="overline" sx={{ color: '#ffffff', fontWeight: 'bold' }}>
                    Due Date:
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'text.primary' }}>
                    {endDate}
                  </Typography>
                </Box>
              </Stack>
            )}
            <>
              <Typography alignItems={'center'} variant="subtitle1" sx={{ mt: 2 }}>
                Designers List
              </Typography>
              <Scrollbar sx={{ width: '100%', height: 100, mt: 1.5 }}>
                <Stack>
                  {details?.projectMembers?.map((row, index) => (
                    <Stack
                      key={index}
                      direction='row'
                      mb={1}
                      spacing={1.5}
                      alignItems='center'
                    >
                      <Avatar src={row?.profile_pic} alt={row?.name} />
                      <Typography variant="subtitle2">
                        {row?.name}
                      </Typography>
                    </Stack>
                  ))}
                </Stack>
              </Scrollbar>
            </>
          </Box>
        </Stack>
        <Stack
          direction={{ xs: 'row', sm: 'row' }}
          sx={{ justifyContent: 'space-between' }}
          spacing={{ xs: 3, sm: 2 }}
        >
          <Box sx={{width:'80%'}}>
            <Stack sx={{flexDirection:'row'}}>
            <Tooltip title='Description'>
              <Description />
            </Tooltip>
            <Typography variant="body2" sx={{ color: '#ffffff', flexWrap:'wrap', ml:2 }}>
              {description}
            </Typography>
            </Stack>
          </Box>
        </Stack>
        <Stack
          direction={{ xs: 'row', sm: 'row' }}
          // sx={{ justifyContent: 'space-between' }}
          spacing={{ xs: 3, sm: 2 }}
        >
          {notes ?
          <>
            <Tooltip title='Notes'>
              <Notes sx={{color: 'error.main'}}/>
            </Tooltip>
            <Typography variant="caption" sx={{ flexWrap:'wrap',color: 'error.main' }}>
              {notes}
            </Typography> 
          </> : ''}
        </Stack>
        <Box
          sx={{
            border: `1px solid ${theme.palette.divider}`, // light border
            borderRadius: "8px",
            p: "4px",
            mb: 2,
          }}
        >
          <StyledTabs
            value={activeTabNew}
            onChange={(e, val) => setActiveTabNew(val)}
            centered
          >
            <StyledTab label="Designs / Files" value="designs" />
            <StyledTab label="References" value="references" />
          </StyledTabs>

          {/* <Divider sx={{ mt: 1 }} /> */}
        </Box>
        {(activeTabNew === 'references') ?
          ((referenceFiles?.length > 0) ? (
            <Box sx={{border: '0.1px solid', borderColor: borderColor,padding:2, }}>
              <Scrollbar sx={{ width: '100%', height: 450 }}>
                {referenceFiles?.length > 0 ?
                  <ImageList  gap={mdd ? 8 : xld ? 12 : 8} cols={mdd ? 3 : xld ? 3 : xs ? 1  : 3}>
                    {referenceFiles?.map((item,index) =>{
                      const { file_type, name, url, extension, approved, reason, status, id } = item;
                      // if (item.approved !== 1 && isClient) return;
                      const isImage = file_type?.startsWith('image/') || file_type ==='img' || file_type ==='image';
                      const isPdf = file_type === 'application/pdf' || file_type === "other" || file_type === "pdf";
                      return (
                        <ImageListItem  key={item.name} sx={{cursor:'pointer', position: 'relative'}}>
                          <Box position="relative">
                            {isImage ? (
                              <a
                              // href={name}
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={(e) => {
                                e.preventDefault();
                                handleImageClickReference(referenceFiles.findIndex((img) => img.name === name))
                              }}
                            >
                              <img
                                srcSet={`${item.name}?w=240&h=240&fit=crop&auto=format&dpr=2 2x`}
                                src={`${item.name}?w=240&h=240&fit=crop&auto=format`}
                                alt={item.title}
                                loading="lazy"
                                style={{ width: '240px', height: '240px' }}
                              />
                              </a>
                            ) : isPdf ? (
                              <Box display="flex" alignItems="center">
                              {/* PDF Icon Button */}
                              <Tooltip title='View'>
                                <IconButton 
                                onClick={() => {
                                  setPdfLoading(true);
                                  setSelectedPDF(name);
                                  setSelectedPDFItem(item);
                                  setOpenPDFModal(true);
                                  setUseOfficeViewer(true); // Reset to try Office viewer first
                                }}
                                  aria-label="open pdf"
                                  sx={{ position:'absolute', 
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    zIndex: 200,color:theme.palette.error.main, backgroundColor:theme.palette.text.primary }} >
                                  <PictureAsPdf style={{ fontSize: 40 }} />
                                </IconButton>
                              </Tooltip>
                        
                              {/* Iframe */}
                              <iframe
                                src={name}
                                title={name}
                                style={{ width: project ? '150px' :'240px', height: '240px' }}
                                frameBorder="0"
                              />
                              <DialogAnimate open={openPDFModal} onClose={() => setOpenPDFModal(false)}>
                                <Card className={classes.dialogContent}>
                                  <div style={{width:'90%', display:'flex',justifyContent:'space-between', marginBottom: '15px',marginLeft:'25px' }}>
                                      
                                      <Button
                                        variant="outlined"
                                        color="primary"
                                        onClick={() => {
                                          if (isClient || userType === 3) {
                                            // For clients/userType 3: Open PDF in new window without toolbar
                                            const newWindow = window.open('', '_blank');
                                            newWindow.document.write(`
                                              <html>
                                                <head>
                                                  <title>PDF Viewer</title>
                                                  <style>
                                                    body { margin: 0; padding: 0; overflow: hidden; }
                                                    iframe { width: 100vw; height: 100vh; border: none; }
                                                  </style>
                                                </head>
                                                <body>
                                                  <iframe src="${selectedPDF}#toolbar=0&navpanes=0&scrollbar=0" title="PDF Viewer"></iframe>
                                                </body>
                                              </html>
                                            `);
                                            newWindow.document.close();
                                          } else {
                                            // For other users: Open PDF normally
                                            window.open(selectedPDF, '_blank');
                                          }
                                        }}
                                        disabled={!selectedPDF}
                                        startIcon={<Icon icon={filePdfIcon} width={20} height={20} />}
                                        sx={{
                                          fontSize:'14px'
                                        }}
                                      >
                                        View PDF
                                      </Button>
                                  </div>
                                  {pdfLoading && (
                                    <Skeleton variant="rectangular" width="100%" height={500} />
                                  )}

                                  {(isClient || userType === 3) && useOfficeViewer ? (
                                    <iframe
                                      src={`https://docs.google.com/gview?url=${encodeURIComponent(selectedPDF)}&embedded=true&toolbar=0&navpanes=0&scrollbar=0`}
                                      title="Selected PDF"
                                      width="100%"
                                      height="500px"
                                      frameBorder="0"
                                      style={{ display: pdfLoading ? 'none' : 'block' }}
                                      onLoad={() => setPdfLoading(false)}
                                      onError={() => {
                                        // If Google Docs viewer fails, fallback to direct iframe
                                        setUseOfficeViewer(false);
                                        setPdfLoading(false);
                                      }}
                                    />
                                  ) : (
                                    <iframe
                                      src={selectedPDF}
                                      title="Selected PDF"
                                      width="100%"
                                      height="500px"
                                      frameBorder="0"
                                      style={{ display: pdfLoading ? 'none' : 'block' }}
                                      onLoad={() => setPdfLoading(false)}
                                    />
                                  )}
                                </Card>
                              </DialogAnimate>
                            </Box>
                            ) : (
                              <Typography 
                                sx={{
                                  color:theme.palette.error.main, 
                                  alignItems:'center', 
                                  justifyContent:'center',
                                  width: project ? '150px' :'240px', height: '240px'
                                }}>
                                Unsupported file type</Typography>
                            )}
                            <ImageListItemBar
                            sx={{
                              width:mdd? '92%':sm ? '20%' :xld?"70%":xs ?'35%' :'82%',                 
                            }}
                              subtitle={moment
                                .unix(item.timestamp)
                                .format('MM/DD/YYYY')}
                            />
                          </Box>
                        </ImageListItem>
                      )
                    })}
                  </ImageList>
                : '' }
              </Scrollbar>
            </Box>
          ) : 
          <Stack alignItems={'center'} justifyContent={'center'} >
            <Typography>
              No References Found
            </Typography>
          </Stack>
        ) : (
          <>
          {userType !==3 ? ((details?.send_client_app_req && designs?.length > 0) ? (
            <Box display="flex" justifyContent="center" mb={2} gap={2} alignItems="center">
              <Button
                variant={activeTab === 'designs' ? 'contained' : 'outlined'}
                onClick={() => setActiveTab('designs')}
              >
                Designs
              </Button>
              <Button
                variant={activeTab === 'files' ? 'contained' : 'outlined'}
                onClick={() => setActiveTab('files')}
              >
                Files
              </Button>
              {selectedDesigns.length > 0 && (
                <Tooltip title={`Send ${selectedDesigns.length} design${selectedDesigns.length !== 1 ? 's' : ''} to email`}>
                  <Badge badgeContent={selectedDesigns.length} color="error">
                    <IconButton
                      color="primary"
                      onClick={handleSendSelectedDesignsToEmail}
                      sx={{
                        ml: 2,
                        backgroundColor: (theme) => theme.palette.primary.main,
                        color: (theme) => theme.palette.primary.contrastText,
                        '&:hover': {
                          backgroundColor: (theme) => theme.palette.primary.dark,
                        },
                      }}
                    >
                      <Icon icon={emailFillIcon} width={24} height={24} />
                    </IconButton>
                  </Badge>
                </Tooltip>
              )}
            </Box>
          ) : (
            selectedDesigns.length > 0 && (
              <Box display="flex" justifyContent="flex-end" mb={2}>
                <Tooltip title={`Send ${selectedDesigns.length} design${selectedDesigns.length !== 1 ? 's' : ''} to email`}>
                  <Badge badgeContent={selectedDesigns.length} color="error">
                    <IconButton
                      color="primary"
                      onClick={handleSendSelectedDesignsToEmail}
                      sx={{
                        backgroundColor: (theme) => theme.palette.primary.main,
                        color: (theme) => theme.palette.primary.contrastText,
                        '&:hover': {
                          backgroundColor: (theme) => theme.palette.primary.dark,
                        },
                      }}
                    >
                      <Icon icon={emailFillIcon} width={24} height={24} />
                    </IconButton>
                  </Badge>
                </Tooltip>
              </Box>
            )
          )) : (
            selectedDesigns.length > 0 && (
              <Box display="flex" justifyContent="flex-end" mb={2}>
                <Tooltip title={`Send ${selectedDesigns.length} design${selectedDesigns.length !== 1 ? 's' : ''} to email`}>
                  <Badge badgeContent={selectedDesigns.length} color="error">
                    <IconButton
                      color="primary"
                      onClick={handleSendSelectedDesignsToEmail}
                      sx={{
                        backgroundColor: (theme) => theme.palette.primary.main,
                        color: (theme) => theme.palette.primary.contrastText,
                        '&:hover': {
                          backgroundColor: (theme) => theme.palette.primary.dark,
                        },
                      }}
                    >
                      <Icon icon={emailFillIcon} width={24} height={24} />
                    </IconButton>
                  </Badge>
                </Tooltip>
              </Box>
            )
          )}
          {(userType === 3 ? (details?.send_client_app_req || approvedDesigns?.length > 0) : designs?.length >0) ? (
            <Box sx={{border: '0.1px solid', borderColor: borderColor,padding:2, }}>
              <Scrollbar sx={{ width: '100%', height: 450 }}>
              {filteredDesigns?.length > 0 ?
                <ImageList  gap={mdd ? 8 : xld ? 12 : 8} cols={mdd ? 3 : xld ? 3 : xs ? 1  : 3}>
                  {/* <ImageListItem key="Subheader" cols={2}> */}
                  {/* </ImageListItem> */}
                  {filteredDesigns?.map((item,index) =>{
                      // const { file_type, name, url } = item;
                      // const isImage = file_type?.startsWith('image/') || file_type ==='img';
                      // const isPdf = file_type === 'application/pdf';
                      const { file_type, name, url, extension, approved, reason, status, id } = item;
                      if (item.approved !== 1 && isClient) return;
                      const isImage = file_type?.startsWith('image/') || file_type ==='img' || file_type ==='image';
                      // const isPdf = file_type === 'application/pdf' || extension=='pdf';
                      const isPdf = file_type === 'application/pdf' || file_type === "other" || file_type === "pdf" ;
                      const isSelected = selectedDesigns?.includes(id);
                      const handleToggle = () => {
                        setSelectedDesigns((prev) =>
                          isSelected ? prev?.filter((n) => n !== id) : [...prev, id],
                        )
                      }
                    return (
                    <ImageListItem  key={item.name} sx={{cursor:'pointer', position: 'relative'}}>
                      <Box position="relative">
                        <Checkbox
                          checked={isSelected}
                          onChange={handleToggle}
                          onClick={(e) => e.stopPropagation()}
                          sx={{
                            position: 'absolute',
                            top: 8,
                            left: 8,
                            zIndex: 10,
                            color: 'black',
                            backgroundColor: theme.palette.grey.A700,
                            boxShadow: 1
                          }}
                        />
                      {/* <Stack sx={{
                        position: 'absolute',
                        zIndex: 9,
                        top: 8,
                        left: 10,
                      }}>
                        {item.approved === 1 ?(
                          <Label
                            variant={'filled'}
                            color={'success'}
                            style={{ color: 'white', height: 20, width: 100 }}
                          >
                            {'Approved'}
                          </Label>                       
                        ): 
                        item.reason ? (
                          <Label
                          variant={'filled'}
                          color={'error'}
                          style={{ color: 'white', height: 20, width: 100 }}
                          >
                          {'Rejected'}
                        </Label>
                        ):null}
                      </Stack>
                      <Stack sx={{
                        position: 'absolute',
                        zIndex: 9,
                        top: 0,
                        left: 10,
                      }}>
                        {item.approved === 1 ? (''
                          // <Typography sx={{ position: 'absolute', top: 40, zIndex: 100 }}>
                          //   <Label
                          //     variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                          //     color="success"
                          //   >
                          //     <Tooltip title={item.approved_by}>
                          //       <Typography
                          //         variant="subtitle2"
                          //         sx={{
                          //           fontSize: '12px',
                          //           cursor: 'pointer',
                          //           display: 'inline-block',
                          //           maxWidth: 150, // Adjust as necessary
                          //           overflow: 'hidden',
                          //           textOverflow: 'ellipsis',
                          //           whiteSpace: 'nowrap',
                          //         }}
                          //       >
                          //         <span
                          //           style={{
                          //             overflow: 'hidden',
                          //             textOverflow: 'ellipsis',
                          //             whiteSpace: 'nowrap',
                          //           }}
                          //         >
                          //           Approved By: {item.approved_by}
                          //         </span>
                          //       </Typography>
                          //     </Tooltip>
                          //   </Label>
                          // </Typography>

                        ) : item.reason ? 
                        <Typography sx={{ position: 'absolute', top: 40, zIndex: 100 }}>
                        <Label
                          variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                          color="error"
                        >
                          <Tooltip title={item.reason}>
                            <Typography
                              variant="subtitle2"
                              sx={{
                                fontSize: '12px',
                                cursor: 'pointer',
                                display: 'inline-block',
                                maxWidth: 150, // Adjust as necessary
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                              }}
                            >
                              <span
                                style={{
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                }}
                              >
                                Rejected Reason: {item.reason}
                              </span>
                            </Typography>
                          </Tooltip>
                        </Label>
                      </Typography>
                        : ''}
                      </Stack> */}
                          {isImage ? (
                            <a
                            // href={name}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(e) => {
                              e.preventDefault();
                              handleImageClick(imageDesigns.findIndex((img) => img.name === name))
                            }}
                          >
                            <img
                              // srcSet={`https://gratisography.com/wp-content/uploads/2025/01/gratisography-dog-vacation-1170x780.jpg?w=240&h=240&fit=crop&auto=format&dpr=2 2x`}
                              // src={`https://gratisography.com/wp-content/uploads/2025/01/gratisography-dog-vacation-1170x780.jpg?w=240&h=240&fit=crop&auto=format`}
                              srcSet={`${item.name}?w=240&h=240&fit=crop&auto=format&dpr=2 2x`}
                              src={`${item.name}?w=240&h=240&fit=crop&auto=format`}
                              alt={item.title}
                              loading="lazy"
                              style={{ width: '240px', height: '240px' }}
                            />
                            </a>
                          ) : isPdf ? (
                            <Box display="flex" alignItems="center">
                            {/* PDF Icon Button */}
                            <Tooltip title='View'>
                              <IconButton 
                              onClick={() => {
                                setPdfLoading(true);
                                setSelectedPDF(name);
                                setSelectedPDFItem(item);
                                setOpenPDFModal(true);
                                setUseOfficeViewer(true); // Reset to try Office viewer first
                              }}
                                aria-label="open pdf"
                                sx={{ position:'absolute', 
                                  top: '50%',
                                  left: '50%',
                                  transform: 'translate(-50%, -50%)',
                                zIndex: 200,color:theme.palette.error.main, backgroundColor:theme.palette.text.primary }} >
                                <PictureAsPdf style={{ fontSize: 40 }} />
                              </IconButton>
                            </Tooltip>
                      
                            {/* Iframe */}
                            <iframe
                              src={name}
                              title={name}
                              style={{ width: project ? '150px' :'240px', height: '240px' }}
                              frameBorder="0"
                            />
                            <DialogAnimate open={openPDFModal} onClose={() => setOpenPDFModal(false)}>
                              <Card className={classes.dialogContent}>
                                <div style={{width:'90%', display:'flex',justifyContent:'space-between', marginBottom: '15px',marginLeft:'25px' }}>
                                    <Button
                                      variant="contained"
                                      color="primary"
                                      onClick={() => handleSendCurrentItemToEmail(selectedPDFItem)}
                                      disabled={!selectedPDFItem}
                                      startIcon={<Icon icon={emailFillIcon} width={20} height={20} />}
                                      sx={{
                                        fontSize:'14px'
                                      }}
                                    >
                                      Send to Email
                                    </Button>
                                    <Button
                                      variant="outlined"
                                      color="primary"
                                      onClick={() => {
                                        if (isClient || userType === 3) {
                                          // For clients/userType 3: Open PDF in new window without toolbar
                                          const newWindow = window.open('', '_blank');
                                          newWindow.document.write(`
                                            <html>
                                              <head>
                                                <title>PDF Viewer</title>
                                                <style>
                                                  body { margin: 0; padding: 0; overflow: hidden; }
                                                  iframe { width: 100vw; height: 100vh; border: none; }
                                                </style>
                                              </head>
                                              <body>
                                                <iframe src="${selectedPDF}#toolbar=0&navpanes=0&scrollbar=0" title="PDF Viewer"></iframe>
                                              </body>
                                            </html>
                                          `);
                                          newWindow.document.close();
                                        } else {
                                          // For other users: Open PDF normally
                                          window.open(selectedPDF, '_blank');
                                        }
                                      }}
                                      disabled={!selectedPDF}
                                      startIcon={<Icon icon={filePdfIcon} width={20} height={20} />}
                                      sx={{
                                        fontSize:'14px'
                                      }}
                                    >
                                      View PDF
                                    </Button>
                                </div>
                                {pdfLoading && (
                                  <Skeleton variant="rectangular" width="100%" height={500} />
                                )}

                                {(isClient || userType === 3) && useOfficeViewer ? (
                                  <iframe
                                    src={`https://docs.google.com/gview?url=${encodeURIComponent(selectedPDF)}&embedded=true&toolbar=0&navpanes=0&scrollbar=0`}
                                    title="Selected PDF"
                                    width="100%"
                                    height="500px"
                                    frameBorder="0"
                                    style={{ display: pdfLoading ? 'none' : 'block' }}
                                    onLoad={() => setPdfLoading(false)}
                                    onError={() => {
                                      // If Google Docs viewer fails, fallback to direct iframe
                                      setUseOfficeViewer(false);
                                      setPdfLoading(false);
                                    }}
                                  />
                                ) : (
                                  <iframe
                                    src={selectedPDF}
                                    title="Selected PDF"
                                    width="100%"
                                    height="500px"
                                    frameBorder="0"
                                    style={{ display: pdfLoading ? 'none' : 'block' }}
                                    onLoad={() => setPdfLoading(false)}
                                  />
                                )}
                              </Card>
                            </DialogAnimate>
                          </Box>
                          ) : (
                            <Typography 
                              sx={{
                                color:theme.palette.error.main, 
                                alignItems:'center', 
                                justifyContent:'center',
                                width: project ? '150px' :'240px', height: '240px'
                              }}>
                              Unsupported file type</Typography>
                          )}
                      <ImageListItemBar
                      sx={{
                        width:mdd? '92%':sm ? '20%' :xld?"70%":xs ?'35%' :'82%',                 
                      }}
                        // title={item.updated_by}
                        subtitle={moment
                          .unix(item.timestamp)
                          .format('MM/DD/YYYY')}
                        // actionIcon={
                        //    <>                       
                        //    {!user.isVendor&& !project&&(
                        //   <UserMoreMenu
                        //     common={{
                        //       name: (item?.approved !== 1 && item?.product_id !== null) && 'Approve',
                        //       function:
                        //       (item?.approved !== 1 && item?.product_id !== null) ? () => {
                        //         setItemId(item.id)
                        //         setModalClose(true)
                        //         handleUpdateDesign({
                        //           id: item.id,
                        //           // product_id: product.product_id,
                        //           approved: 1,
                        //           reason:null
                        //         })
                        //         // setOpenProductModel(true)
                        //       } : null ,
                        //       Iccon:
                        //       (item?.approved !== 1 && item?.product_id !== null) && (
                        //           <ThumbUpAltOutlined />
                        //         ),
                        //       modalClose: modalClose,
                        //     }}
                        //     linkImageWithTask={{
                        //       name: item?.product_id == null && 'Link with catalog',
                        //       function:
                        //       item?.product_id == null ? () => {
                                      
                        //               setItemId(item.id)
                        //               setModalClose(true)
                        //               setOpenProductModel(true)
                        //             } : null ,
                        //       Iccon: item?.product_id == null && (
                        //           <Link />
                        //         ),
                        //       modalClose: modalClose,
                        //     }}

                        //     common2={{
                        //       name: (item?.approved === 1 || (item?.approved === 0 && item?.reason === null)) && 'Reject',
                        //       function:
                        //       (item?.approved === 1 || (item?.approved === 0 && item?.reason === null)) ? () => {
                        //                 setItemId(item.id)
                        //                 setOpenReasonModal(true)
                        //             } : null ,
                        //       Iccon:
                        //       (item?.approved === 1 || (item?.approved === 0 && item?.reason === null)) && (
                        //           <ThumbDownOffAltOutlined />
                        //         )
                        //         ,
                        //       modalClose: modalClose,
                        //     }}
                        //     //   onDelete={() => handleUpdateDesign({ id: item.id, status: 0 })}
                        //     {...(item.approved === 1
                        //       ? {}
                        //       : {
                        //           onDelete: () =>
                        //             handleUpdateDesign({
                        //               id: item.id,
                        //               status: 0,
                        //             }),
                        //         })}
                        //   />
                        //   )}                          
                        //   </>
                        // }
                        actionIcon={
                            <>
                              {!user.isVendor && !project && (designStatus !==2 && send_client_app_req === 0 || designStatus ===6 || item?.isDesign === 2) && (
                                <UserMoreMenu
                                  {...{
                                    onDelete: () =>
                                      handleDeleteDesign({
                                        id: item.id
                                      }),
                                  }}
                                />
                              )}
                            </>
                          }
                      />
                      {openProductModel && itemId === item.id && <Card sx={{ position:'absolute', zIndex: 10, bottom: 5,left: 5,p: 2}}>
                        <Stack direction={'row'} justifyContent={'space-between'}>
                        <Typography marginBottom={2} variant='subtitle2'>Choose Product</Typography>
                        <CancelOutlined sx={{ cursor: 'pointer' }} onClick={()=>{
                          setModalClose(false)
                          setOpenProductModel(false)
                          }}/>
                        </Stack>
                        <Divider sx={{ marginBottom: 2}}/>
                      <Stack spacing={1}>
                        {
                          products?.filter((prodItem)=>prodItem?.material===0 && prodItem?.rfp===0)?.map((product) => 
                            <><Typography sx={{ cursor: 'pointer' }} variant='caption' onClick={()=>handleUpdateDesign({
                                      id: item.id,
                                      product_id: product.product_id,
                                      product_name: product.product_name,
                                      // approved: 1,
                                      reason:null
                                    })}>{product.product_name}</Typography>
                                    <Divider/>
                                    </>
                          )
                        }
                        </Stack>
                      </Card>}
                      
                      <Modal
                          open={openReasonModal && itemId === item.id}
                          handleClose={() => {
                            setOpenReasonModal(false)
                          }}
                          modalTitle={`Reason for Design Rejection`}
                        >
                          
                              <Grid container justifyContent="center" alignItems="center">
                                <Grid item xs={12} >
                                  <TextField
                                    fullWidth
                                    label="Reason"
                                    value={reasonText}
                                    onChange={(e) => setReasonText(e.target.value)}
                                  />
                                  <Box
                                    sx={{
                                      mt: 3,
                                      display: 'flex',
                                      justifyContent: 'center',
                                      gap: 1,
                                    }}
                                  >
                                    <LoadingButton
                                      type="submit"
                                      variant="contained"
                                      onClick={()=>handleUpdateDesign({
                                        id: itemId,
                                        reason: reasonText,
                                        approved: 0,
                                      })}
                                      // loading={isSubmitting}
                                    >
                                      {' Save '}
                                    </LoadingButton>
                                    <Button
                                      variant="outlined"
                                      type="submit"
                                      onClick={() => {
                                        setOpenReasonModal(false)
                                      }}
                                    >
                                      Cancel
                                    </Button>
                                  </Box>
                                </Grid>
                              </Grid>
                        </Modal>
                      </Box>
                    </ImageListItem>
                    )
                    })}
                </ImageList>
              : 
                <Stack alignItems={'center'} justifyContent={'center'} >
                  <Typography>
                    {activeTab === 'files' ? 'No Files Found' : 'No Designs Found'}
                  </Typography>
                </Stack>
              }
              </Scrollbar>
            </Box>
          ) : (
            ''
          )}
          </>
        )}
      </Stack>
      <Modal width={1000}
              open={openImageModal}
              handleClose={() => {
                setOpenImageModal(false);
              }}
              modalTitle={'Designs'}
              >
              <Stack spacing={2}>
                <Box display="flex" justifyContent="flex-end" mb={1}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleSendCurrentItemToEmail(imageDesigns[currentImageIndex])}
                    disabled={!imageDesigns || imageDesigns.length === 0 || currentImageIndex === null}
                    startIcon={<Icon icon={emailFillIcon} width={20} height={20} />}
                  >
                    Send to Email
                  </Button>
                </Box>
                <div
                style={{
                  position: 'relative',
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  gap:'1rem',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
            <IconButton
              onClick={handlePrevious}
              disabled={currentImageIndex === 0}
              sx={{
                opacity: currentImageIndex === 0 ? 0.3 : 1,
                pointerEvents: currentImageIndex === 0 ? 'none' : 'auto',
              }}
            >
              <Icon
                icon={arrowLeftOutlined}
                width={24}
                height={24}
                color="#006097"
              />
            </IconButton>

            <Box
            component={'div'} 
              style={{
                width: '500px',
                height: '500px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: 8,
                overflow: 'hidden',
              }}
            >
              <img
                src={imageDesigns[currentImageIndex]?.name}
                // src={`https://gratisography.com/wp-content/uploads/2025/01/gratisography-dog-vacation-1170x780.jpg`}
                alt={`Image ${currentImageIndex + 1}`}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  borderRadius: 8,
                }}
              />
            </Box>
            <IconButton
              onClick={handleNext}
              disabled={currentImageIndex === imageDesigns.length - 1}
              sx={{
                opacity: currentImageIndex === imageDesigns.length - 1 ? 0.3 : 1,
                pointerEvents: currentImageIndex === imageDesigns.length - 1 ? 'none' : 'auto',
              }}
            >
              <Icon
                icon={arrowRightOutlined}
                width={24}
                height={24}
                color="#006097"
              />
            </IconButton>
          </div>
          </Stack>
        </Modal>

      <Modal width={1000}
        open={openImageModalReference}
        handleClose={() => {
          setOpenImageModalReference(false);
        }}
        modalTitle={'References'}
      >
        <Stack spacing={2}>
          <div
            style={{
              position: 'relative',
              width: '100%',
              height: '100%',
              display: 'flex',
              gap:'1rem',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <IconButton
              onClick={handlePrevious}
              disabled={currentImageIndex === 0}
              sx={{
                opacity: currentImageIndex === 0 ? 0.3 : 1,
                pointerEvents: currentImageIndex === 0 ? 'none' : 'auto',
              }}
            >
              <Icon
                icon={arrowLeftOutlined}
                width={24}
                height={24}
                color="#006097"
              />
            </IconButton>

            <Box
              component={'div'} 
              style={{
                width: '500px',
                height: '500px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: 8,
                overflow: 'hidden',
              }}
            >
              <img
                src={referenceFiles[currentImageIndex]?.name}
                // src={`https://gratisography.com/wp-content/uploads/2025/01/gratisography-dog-vacation-1170x780.jpg`}
                alt={`Image ${currentImageIndex + 1}`}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  borderRadius: 8,
                }}
              />
            </Box>
            <IconButton
              onClick={handleNext}
              disabled={currentImageIndex === imageDesigns.length - 1}
              sx={{
                opacity: currentImageIndex === imageDesigns.length - 1 ? 0.3 : 1,
                pointerEvents: currentImageIndex === imageDesigns.length - 1 ? 'none' : 'auto',
              }}
            >
              <Icon
                icon={arrowRightOutlined}
                width={24}
                height={24}
                color="#006097"
              />
            </IconButton>
          </div>
        </Stack>
      </Modal>
        <SendDesignsEmailModal
          open={openEmailModal}
          onClose={() => setOpenEmailModal(false)}
          selectedDesigns={emailModalDesigns}
          designOrderId={details?.id}
          userId={user.user_id}
          userType={userType}
          onSuccess={handleEmailSent}
        />
      {/* {(user.isVendor === null || user.isVendor === 0) &&(
      <AccountNotifications
                  isRequest={true}
                  requestId={requestId}
                 signAgreements={signAgreements}
                 customTemplate={customTemplate}
                 questionnaireTemplate={questionnaireTemplate}
                 allDataEmpty={allDataEmpty}
                 portfolio={portfolio}
                 updatingFunction={fetchRequestDetails}/>
                 )} */}
    </Card>
  )
}